import React, { useState, useEffect } from 'react'
import { Col, Row, PageHeader, Segmented, Modal, Input, Button } from 'antd'
import i18next from 'i18next'
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { useTranslation } from 'react-i18next';
import i18n from './i18n'
import Calculator from './components/calculator/Calculator'
import Datatable from './components/Datatable/Datatable'
import Logos from './components/Logos/Logos'

const App = () => {
  const { t } = useTranslation();
  const [forensicData, setForensicData] = useState();
  const [factors, setFactors] = useState();
  const [lang, setLang] = useState();
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [enableButton, setEnableButton] = useState(true);
  const [userCaptcha, setUserCaptcha] = useState();
  useEffect(() => loadCaptchaEnginge(6), []);

  const doSubmit = () => {
    if (validateCaptcha(userCaptcha) === true) {
      setIsModalVisible(false);
      setEnableButton(false);
    }
    else {
      setUserCaptcha('');
    }
  }
  const insertValue = (event) => {
    setUserCaptcha(event.target.value);
  }

  const setLangAction = () =>{
    i18n.changeLanguage(lang === 'English' ? 'es' : 'en');
    setLang(i18next.language === 'en' ? 'English' : 'Español');
  }

  return (
    <div className="App">
      <Row justify='center' style={{ width: '100%', padding: '0px 10px' }}>
        <Col span={24} style={{ width: '100%' }}>
          <Logos />
          <Row justify='center' style={{ width: '100%' }}>
            <Col style={{ display: 'flex', backgroundColor: '#ec7771', alignItems: 'center', borderRadius: '3px', width: '100%' }}>
              <Col  style={{ width: '100%' }}>
                <PageHeader
                  className="site-page-header"
                  title="Forensic International Dental Data Base v.3"
                  subTitle="(FIDB.3)"
                  style={{ padding: '0.1em', marginLeft: '0.5em' }} />
              </Col>
              <Col span={2} style={{ display: 'flex', justifyContent: 'end' }}><Segmented options={['English', 'Español']} value={lang} onChange={setLangAction} style={{ margin: '0.5em' }} defaultValue={i18next.language === 'en' ? 'English' : 'Español'} /></Col>
            </Col>
          </Row>
          <Row justify="center" aling="top" style={{ paddingTop: '2em' }}>
            <Col style={{ justifyContent: 'center', width: '100%' }}>
              <Calculator forensicData={setForensicData} setFactors={setFactors} buttonState={enableButton} />
            </Col>
          </Row>
          <Row justify="center" aling="top" style={{ paddingTop: '2em', width: '100%' }}>
            <Col style={{ justifyContent: 'center', fontSize: '11px' }}>
              <Datatable data={forensicData} factors={factors} />
              <p>{t('description.tablefoot')}</p>
              <p>{t('description.references')}</p>
              <p><sup>1</sup>{t('description.tablefootnote1')}</p>
              <p><sup>2</sup>{t('description.tablefootnote2')}</p>
              <p><sup>3</sup>{t('description.tablefootnote3')}</p>
              <p>{t('description.tablefootnote4')}<br />
                {t('description.tablefootnote5')}</p>
            </Col>
          </Row>
          <Row justify="center" aling="top" style={{ paddingTop: '2em' }}>
          <div><p>build by <a href="https://wannacode.ar//">Commit36</a></p></div>
          </Row>
          <Modal title={t('description.captchaTitle')} visible={isModalVisible} centered closable={false} footer={<Button onClick={() => doSubmit()} >{t('description.captchaButton')}</Button>}>
            <LoadCanvasTemplate reloadText={t('description.captchaReload')} />
            <Input style={{ marginTop: '1em', marginBottom: '1em' }} onChange={insertValue} value={userCaptcha} />
          </Modal>
        </Col>
      </Row >
    </div >
  );
}

export default App
